import { apiClient } from '~/api';
import type { LocationsMapPageData } from '~/types/pages/locationsMapPageData';

export default async function getLocationsMapPage(locale: string) {
  const a11Store = useA11yStore();
  const { enabled: a11yEnabled } = storeToRefs(a11Store);
  const headers = a11yEnabled.value ? { 'a11y-enabled': 'true' } : undefined;

  return await apiClient<LocationsMapPageData>('/pages/locations-map-page', {
    cacheKey: getApiRequestCacheKey('locationsMapPage', {
      a11y: Boolean(a11yEnabled.value).toString(),
      locale,
    }),
    params: {
      locale,
      headers,
    },
  });
}
